import { SET_CARRIER_DASHBOARD_DATA } from "./ActionTypes";

const initialState = {
  carrierDashboardData: [],
  // other states
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CARRIER_DASHBOARD_DATA:
      return {
        ...state,
        carrierDashboardData: action.payload,
      };

    // other cases...

    default:
      return state;
  }
};

export default dashboardReducer;
